import { asset$ } from "modules/asset/asset$";
import { map } from "rxjs";
import { News } from "types";

export const newsViewModel$ = asset$.pipe(map((assetState) => {
  const news = Object.values(assetState.byId).filter(e => e.type === 'news') as News[]
  const sorted = news.sort((a, b) => ((a.featured || b.featured) && +!!b.featured - +!!a.featured) || b.createdAt - a.createdAt)
  return {
    news: sorted,
    visibleNews: sorted.filter(e => e.published),
    byShortid: Object.fromEntries(sorted.map(item => [item.shortid, item])),
    byId: Object.fromEntries(sorted.map(item => ([item.id, item]))),
    byParam: Object.fromEntries(sorted.map(item => ([[`${item.type}-${item.shortid}`], item])))
  }
}))
